import React from "react";

interface FileDialogProps {
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
  accept?: string;
}

const FileDialog = React.forwardRef<HTMLInputElement, FileDialogProps>(
  ({ onInputChange, multiple = true, accept = "image/*,video/*" }, ref) => {
    return (
      <input
        ref={ref}
        type="file"
        style={{ display: "none" }}
        accept={accept}
        multiple={multiple}
        onChange={onInputChange}
      />
    );
  },
);
FileDialog.displayName = "FileDialog";

export default FileDialog;
